export const comunita = [
	/*COMUNITA' MINORI, MAMMA */
	"Com. Educativa per Minori  \"LO SCOIATTOLO\"  (Cooperativa Terra Mia),	Corso Casale, 246, 10132 Torino",
	"Com. Genitore-Bambino \"MAIA\"  (Coop. \"Il Margine\"), Via Vanchiglia, 2",
	"Com. mamma-bambino  \"Pozzo di Sichar\" (Coop Esserci), Via Torricelli 68, Torino",
	"Com. genitore-bambino \"CASA AURORA\" (GRUPPO ARCO), Via Capriolo 16, Torino",
	"Com. mamma-bambino \"Casa Ishtar\" (Educare Coop), Via Manzoni 15, Torino",
	"Casa famiglia \"Casa Vallagarina\" (Fondazione difesa fanciulli), Via Val Lagarina 4, Torino",
	"Com. mamma-bambino \"Casa Mia\" (Gruppo Arco), Corso Lecce 33/33, Torino",
	"Com. mamma-bambino \"Opera Pia Viretti\", Strada San Vincenzo 137, Torino",
	"Com. mamma-bambino \"Stella\" (Coop Il Margine), Via Passo Buole 166, Torino",
	"Com. per minori \"CASA VALPIANA\" (Fondazione difesa fanciulli), Strada Valpiana 37, Torino",
	"Com. alloggio \"casa dei bimbi\", Corso Vittorio Emanuele II 119, Torino",
	"Com. Minori Stranieri non accompagnati \"Casa che accoglie\" (Salesiani Don Bosco), Via Ormea 4, Torino",
	"Centro diurno educativo minorile \"Lo Spazio\" (Coop Esserci), Via Guido Reni 96/148, Torino",
	"Com.minori stranieri non accompagnati \"La Rondine\" (Gruppo Arco), Via Capriolo 20/A, Torino",
	"Centro Aggregativo diurno perMinori \"Yawp\" (Coop Educare), Via Vibò, 28, Torino",
	"Centro diurno minori San Paolo (Salesiani san paolo), Via Emanuele Loserna di Rorà 16, Torino",
	"Com. Educativa residenziale femminile per minori \"Kiki\" (Coop Valpiana), Via Le Chiuse 14, Torino",
	"Servizio Ser minori Il Cormorano (Coop strana idea), Via Paolo Veronese 108, Torino",
	"Centro Diurno Aggregativo per minori Cecchi Point (coop. Educadore), Via Antonio Cecchi 17, Torino",
	"Comunità Alloggio educativa residenziale per minori \"La casa di Pallina\" (Coop Chronos), Corso Quintino Sella 79, Torino",
	"Com. Minori Stranieri non accompagnati \"Casa Samir\"(Coop Educare), P.za Chiesa della Salute 17, Torino",
	"CRP Laura, Strada Antica di Revigliasco 65, Torino",
	"Com. mamma-bambino \"Ibap Casa Magnolia\" (Casa Benefica), Via Saluzzo 44, Torino",
	"Centro Aggregativo per Minori \"Artigianelli\" (Coop Educare), Via Manzoni 15, Torino",
	"Il Germoglio Pensionato integrato GVV Torino, Via Saccarelli 2, Torino",
	"CERV illaSole, Strada Antica di Revigliasco 45, Torino",
	
	/*COMUNITA' RELIGIOSE*/
	"ISTITUTO FLORA, Via San Francesco da Paola 42, TORINO",
	"PICCOLE SORELLE DEI POVERI, Corso Francia 180 - 10145, TORINO",
	"PICCOLE SORELLE DEL VANGELO, Via Renato Martorelli 75 - 10155, TORINO",
	"POVERE FIGLIE DI S.GAETANO, Via Giaveno 2 - 10152, TORINO",
	"SEMINARIO DI TORINO, Via Lanfra,nchi 10",
	"SERVE DEL SIGNORE E DELLA VERGINE DI  MATARA ', Via Pietro Cossa 280/2 - 10151, TORINO",
	"SOCIETA ' DELLE FIGLIE DEL CUORE DI MARIA, Corso Francia 180 - 10145, TORINO",
	"SUORE CAPPUCCINE DI MADRE RUBATTO, Via Caluso 18 - 10148, TORINO",
	"SUORE CARMELITANE DI S.TERESA - TORINO, Corso Alberto Picco 104 - 10131, TORINO",
	"SUORE CARMELITANE DI S.TERESA – TORINO, Corso Farini 26 - 10153, TORINO",
	"SUORE CARMELITANE DI S.TERESA - TORINO, Str. Val S. Martino Int.  48 - 10131, TORINO",
	"SUORE DEL FAMULATO CRISTIANO, Via Lomellina 44 - 10132, TORINO",
	"SUORE DEL S. NATALE, Corso Francia 164  - 10145, TORINO",
	"SUORE DEL SANTO VOLTO, Via Val della Torre 11 - 10149, TORINO",
	"SUORE DELLA CARITA ' DI S.GIOVANNA ANTIDA THOURET, Via Asinari di Bernezzo 34 - 10146, TORINO",
	"SUORE DELL 'ADORAZIONE DEL SS. SACRAMENTO, Corso Benedetto Croce 20 - 10135, TORINO",
	"SUORE DELL 'ADORAZIONE SACRO CUORE, Viale Curreno 21 - 10133, TORINO",
	"SUORE DELL 'IMMACOLATA, Via Passalacqua 5 - 10122, TORINO",
	"SUORE DI CARITA ' DELL 'ASSUNZIONE, Via Natale Palli 31 -10147, TORINO",
	"SUORE DI CARITA ' DI S. MARIA - SUORE DEL BUON CONSIGLIO, Via Curtatone 17 - 10131, TORINO",
	"SUORE DI CARITA ' DI S. MARIA - SUORE DEL BUON CONSIGLIO, Via San Pio V, 11d - 10125, TORINO",
	"SUORE DI CARITA ' DI S. MARIA - SUORE DEL BUON CONSIGLIO, Piazza Toselli 4 - 10132, TORINO",
	"SUORE DI MARIA SANTISSIMA CONSOLATRICE, Via Caprera 46 -10136, TORINO",
	"SUORE DI NOSTRA SIGNORA DEL RITIRO AL CENACOLO, Piazza Gozzano 4 - 10132, TORINO",
	"SUORE DI S.ANNA (Casa madre), Via della Consolata 20 - 10122, TORINO",
	"SUORE DI S.ANNA (Casa Betania), Via della Consolata 20 - 10122, TORINO",
	"SUORE DI S.ANNA (Istituto Sant 'ANNA), Via Massena 36 - 10128, TORINO",
	"SUORE DI S. GIUSEPPE (CUNEO), Via S. Francesco da Paola 43 - 10123, TORINO",
	"SUORE DI S. GIUSEPPE (PINEROLO), Corso Regina Margherita 107 -10122, TORINO",
	"SUORE DI S. GIUSEPPE (PINEROLO), Via Leoncavallo 18 - 10154, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO Curia generalizia, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO Curia provincia lizia, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Istituto San Pietro, Via Miglietti 2 - 10144, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Casa di Formazione, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - ANNUNZIATA, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Casa Betania, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - comunità Cuore di Maria, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - COM EMMAUS, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Madonna delle Grazie, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO _ Com. Madre Nasi, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Comunità S. G.B. Cottolengo, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - TRINITA, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Casa Esercizi, Via Cottolengo 14 - 10152, TORINO",
	"SUORE DI S.GIUSEPPE BENEDETTO COTTOLENGO - Casa Myriam, Via Spotorno 43 - 10126, TORINO",
	"SUORE DI S. MARIA - LORETO, Via Monte Rosa 150 - 10154, TORINO",
	"SUORE DOMENICANE DELL 'IMMACOLATA CONCEZIONE, Via Vernazza 41  - 10136, TORINO",
	"SUORE DOMENICANE DI S. CATERINA DA SIENA, Via Sansovino 83 - 10151, TORINO",
	"SUORE FRANCESCANE ANGELINE, Via Giuseppe Giusti 6 - 10121, TORINO",
	"SUORE FRANCESCANE MISSIONARIE DI SUSA, Via Luisa del Carretto 6 - 10131, TORINO",
	"SUORE IMMACOLATINE, Via Vestignè 7 - 10155, TORINO",
	"SUORE MINIME DI NOSTRA SIGNORA DEL SUFFRAGIO, Via San Donato 31 - 10144, TORINO",
	"SUORE MINIME DI NOSTRA SIGNORA DEL SUFFRAGIO, Corso Quintino Sella 79 - 10132, TORINO",
	"SUORE MISSIONARIE DELLA CONSOLATA, Via Coazze 1 - 10138, TORINO",
	"SUORE MISSIONARIE DELLA CONSOLATA, Via Genova 8/B - 1012,6 TORINO",
	"SUORE MISSIONARIE DI MARIA AIUTO DEI CRISTIANI, Via Cassini 56 - 10129, TORINO",
	"SUORE MISSIONARIE DI MARIA AIUTO DEI CRISTIANI, Corso Regina Margherita 70 - 10153, TORINO",
	"SUORE MURIALDINE DI S. GIUSEPPE, P.za Chiesa della Salute 17ter - 10147, TORINO",
	"UNIONE SUORE DOMENICANE DI S. TOMMASO D 'AQUINO, Via Cosmo 15 - 10131, TORINO",
	"UNIONE SUORE DOMENICANE DI S. TOMMASO D 'AQUINO, Corso Unione Sovietica 225 - 10134, TORINO",
	"CARMELITANI SCALZI, Via Santa Teresa, 5 - 10121, TORINO",
	"CHIERICI REGOLARI MINISTRI DEGLI INFERMI (CAMILLIANI), Via S. Camillo de Lellis 28 - 10121, TORINO",
	"CHIERICI REGOLARI MINISTRI DEGLI INFERMI (CAMILLIANI), Strada Santa Margherita 136 - 10131, TORINO",
	"COMPAGNIA DI GESU ' (GESUITI), Corso Siracusa 10 - 10136, TORINO",
	"CONGREGAZIONE DEL SS.MO SACRAMENTO (SACRAMENTINI), Vicolo Santa Maria, 3 - 10122, TORINO",
	"CONGREGAZIONE DELLA MISSIONE (LAZZARISTI), Via XX Settembre 23 - 10121, TORINO",
	"CONGREGAZIONE  DELL 'ORATORIO DI S. FILIPPO NERI (ORATORIANI), Via Maria Vittoria 5  - 10123, TORINO",
	"CONGREGAZIONE DI S. GIUSEPPE (GIUSEPPINI DEL MURIALDO), Corso Palestro 14 - 10122, TORINO",
	"FRATELLI DELLA SACRA FAMIGLIA DI BELLEY, Via Palmieri 39 - 10138, TORINO",
	"FRATELLI DELLE SCUOLE CRISTIANE, Via Rosolino Pilo 24  - 10143, TORINO",
	"FRATELLI DELLE SCUOLE CRISTIANE, Via S. Francesco da Paola 23 - 10123, TORINO",
	"FRATELLI DELLE SCUOLE CRISTIANE, Strada S.ta Margherita 132 - 10131, TORINO",
	"FRATELLI DI SAN GIUSEPPE BENEDETTO COTTOLENGO (COTTOLENGHINI), Via Cottolengo 14 - 10152, TORINO",
	"FRATERNITA ' SACERDOTALE DEI MISSIONARI DI SAN CARLO BORROMEO, Piazza Santa Giulia 7bis - 10124, TORINO",
	"CONVENTO SANTA MARIA DELLE ROSE, Via Arnaldo da Brescia 22 - 10134, TORINO",
	"ISTITUTO DEL VERBO INCARNATO, Via Baltimora 85 - 10137, TORINO",
	"ISTITUTO MISSIONARI DI MARIA SS. CONSOLATA, Corso Ferrucci 14 - 10138, TORINO",
	"ISTITUTO MISSIONARI DI MARIA SS. CONSOLATA, Via Ceresole 44 - 10155, TORINO",
	"ISTITUTO MISSIONARI DI MARIA SS. CONSOLATA, Via Coazze 21 - 10138, TORINO",
	"MISSIONARI DI NOSTRA SIGNORA DI \"LA SALETTE\", Piazza del Monastero 14 - 10146, TORINO",
	"ORDINE FRANCESCANO FRATI MINORI, Via Sant'Antonio da Padova 7 - 10121, TORINO",
	"ORDINE FRANCESCANO FRATI MINORI, Convento San Bernardino - Via S. Bernardino 11- 10141, TORINO",
	"ORDINE FRANCESCANO FRATI MINORI CAPPUCCINI, p.le Monte dei Cappuccini,3 - 10131,  TORINO",
	"Frati Cappuccini Madonna di Campagna ORDINE FRANCESCANO FRATI MINORI CAPPUCCINI, Via Card. Massaia 98 - 10147, TORINO",
	"ORDINE FRANCESCANO FRATI MINORI CONVENTUALI, Via Monginevro 251 - 10142, TORINO",
	"PICCOLA OPERA DELLA DIVINA PROVVIDENZA (SAN LUIGI ORIONE), Piazza Montale 18 - 10151, TORINO",
	"PICCOLI FRATELLI DI GESU ' (FOUCAULD), Corso Tarasco - Via Massena 5 -10128, TORINO",
	"SOCIETA ' DEI SACERDOTI DI SAN GIUSEPPE BENEDETTO COTTOLENGO (COTT), Via Cottolengo 14 - 10152, TORINO",
	"SOCIETA ' DI MARIA (MARISTI), Corso Francia 29 - 10138, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Maria Ausiliatrice 32 - 10152, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Maria Ausiliatrice 32 - 10152, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI) - Filippo Rinaldi, Via Maria Ausiliatrice 32 - 10152, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Maria Ausiliatrice 32 - 10152, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Madama Cristina 1 - 10125, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Caboto 27 - 10129, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Luserna di Rorà 16 - 10139, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Via Paisiello 37 - 10154, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Piazza Conti Rebaudengo 22 - 10155, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Corso Unione Sovietica 312 - 10135, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Viale Thovez 37 - 10131, TORINO",
	"SOCIETA ' SALESIANA DI S. GIOVANNI BOSCO (SALESIANI), Viale Thovez 43/3 - 10131, TORINO",
	"CONGREGAZIONE DELLO SPIRITO SANTO, Via Monte di Pietà 11 - 10121, TORINO",
	"CONGREGAZIONE DELLO SPIRITO SANTO, Via San Gaetano da Thiene, 2 - 10154, Torino",
	"SOCIETA ' MISSIONARIA DI SAN PAOLO DELLA NIGERIA, Via Fiesole 25 - 10151, TORINO",
	"CASA GIULIA DI BAROLO CONGREGAZIONE FIGLIE DI GESU’ BUON PASTORE, Via Cottolengo 22, Torino",
	
	/*COMUNITA' ALLOGGIO, CENTRI DIURNI*/
	"COOPERATIVA SOCIALE PROGEST Alloggio Stella CometaCORSO PESCHIERA 22210139 TORINO TO",
	"COOPERATIVA SOCIALE PROGEST Comunità del Borgo Via Mottarone CORSO PESCHIERA 22210139 TORINO TO",
	"COOPERATIVA SOCIALE PROGEST Via GolettaCORSO PESCHIERA 22210139 TORINO TO",
	"COOPERATIVA SOCIALE PROGEST Gruppi appartamento via Mercadante 74 CORSO PESCHIERA 22210139 TORINO TO",
	"COOPERATIVA SOCIALE PROGEST Gruppo appartamento La Mansarda CORSO PESCHIERA 22 210139 TORINO TO",
	"CAD Il PuntoSOCIETÀ COOPERATIVA SOCIALE IL PUNTO VIA CIMABUE 2 10137 TORINO",
	"SOCIETÀ COOPERATIVA SOCIALE IL PUNTOVIA CIMABUE 210137 TORINO",
	"RAF CARANE di UKA A.T.I. DOMUS LAETITIAE –Cooperativa ESSERCI.",
	"COOPERATIVA ANIMAZIONE VALDOCCOs.c.s. onlus 10146 TORINO",
	"Casa Sidoli COOPERATIVA ANIMAZIONE VALDOCCOs.c.s. onlus 10146 TORINO Via Le Chiuse 59, Torino",
	"CAD Arte Pura COOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 35 10098 RIVOLI TO",
	"CER La casa di PallinaCOOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 35 10098 RIVOLI TO",
	"Comunità alloggio La BandaCOOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 3510098 RIVOLI TO",
	"Comunità Margherita COOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 3510098 RIVOLI TO",
	"Comunità Mezzaluna COOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 35 10098 RIVOLI TO",
	"Comunità Via Lattea COOPERATIVA SOCIALE CHRONOS VIA ROMBÒ 35 10098 RIVOLI TO",
	"FONDAZIONE AGAPE DELLO SPIRITO SANTO 10122 TORINO",
	"ESSERCI S.C.S. VIA DELLA CONSOLATA 8 10122 TORINO",
	"COOPERATIVA SOCIALE IL MARGINE VIA ERITREA 20 10142 TORINO",
	"COOPERATIVA SOCIALE LA TESTARDA CORSO REGINA MARGHERITA 175 10144 TORINO",
	"COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"COOPERATIVA SOCIALE CLG ENSEMBLE VIA DELLE QUERCE 47 10156 TORINO",
	"Artcadd Centro Diurno COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"Portaperta Comunità COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"R.A.A. Casa dell'Immacolata",
	"RESIDENZIALE DIURNO COOPERATIVA Diecidecimi ANIMAZIONE VALDOCCO s.c.s onlus VIA LE CHIUSE 59 10144 TORINO",
	"RAF diurna Il Centro COOPERATIVA SOCIALE IL MARGINE VIA ERITREA 20 10142 TORINO",
	"RAF diurna Volerevolare COOPERATIVA SOCIALE IL MARGINE VIA ERITREA 20 10142 TORINO",
	" \"L’ARABA FENICE \" Centro diurno socio-terapeutico R.A.F. tipo B",
	"Comunità alloggio Via Fiesole ASSOCIAZIONE ANFFAS O.N.L.U.S VIA CARLO BOSSI 24 10144 TORINO",
	"RAF Diurna via Fiesole ASSOCIAZIONE ANFFAS O.N.L.U.S VIA CARLO BOSSI 24 10144 TORINO",
	"Centro diurno via De Sanctis ASSOCIAZIONE ANFFAS O.N.L.U.S VIA CARLO BOSSI 24 10144 TORINO",
	"CASCINA TEGHILLO INTERACTIVE SOCIETÀ COOPERATIVA SOCIALE VIA UDINE 45/A 10149 TORINO",
	"Comunità Alloggio Discanto COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"Comunità Voltalacarta COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"ASSOCIAZIONE ANFFAS O.N.L.U.S VIA CARLO BOSSI 24 10144 TORINO",
	"Comunità alloggio Sostegno VIA BOGETTO 3 10144 TORINO",
	"CAD - Centro Diurno per disabili VITA NUOVA COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"Gruppo Appartamento disabili ASSOCIAZIONE MARIA SS. ACCOGLIENTE VIA VALDELLATORRE 19/8 10149 TORINO TO",
	"Centro Diurno  \"Cure Familiari \" COOPERATIVA SOCIALE PARADIGMA CORSO STATI UNITI 11H 10128 TORINO",
	"RAF Diurna Il Puzzle COOP. SOCIALE IL SOGNO DI UNA COSA VIA CRISPI 9 10093 COLLEGNO",
	"Comunità Psichiatrica Casa Ferri COOP. SOC. FRASSATI COOP. SOC. PARADIGMA",
	"Comunità Il Dardo Presidio Fioccardo INTERACTIVE SOCIETÀ COOPERATIVA SOCIALE 10151 TORINO",
	"Presidio Fioccardo Centro Diurno INTERACTIVE SOCIETÀ COOPERATIVA SOCIALE VIA SANSOVINO 217 10151 TORINO",
	"c.a. Arcipelago COOPERATIVA SOCIALE IL MARGINE VIA ERITREA 20 10142 TORINO",
	"CAD Cascina la Luna COOP. SOC. FRASSATI COOP. SOC. PARADIGMA",
	"COOPERATIVA CASETTA ANDREA STRADA SAN VINCENZO 137 10131 TORINO",
	"SSER LUNA PARK A.T.I. INTERACTIVE s.c.s. FONDAZIONE TEDA PER L'AUTISMO ONLUS",
	"SSER Minori",
	"Alloggio stranieri Coop Liberitutti",
	"GAP Vega Cooperativa Il Margine",
	"GAP Via Chatillon 4 Cooperativa Il Margine",
	"SPRAR Casa del Mondo. Progetto Tenda.",
	"RAF Momenti Familiari Centro Diurno Cooperativa Frassati",
	"Comunità alloggio Ambienti Familiari Cooperativa Frassati",
	"Centro Diurno Minori Lo Spazio",
	"CAD Super...abile Cooperativa Liberitutti",
	"CADD  \"Creative Time \"",
	"Centro Diurno  \"Raccordi Familiari \" Coop Sociale Paradigma",
	"Servizio Autonomia Disabili Cooperativa San Donato",
	"CENTRO DIURNO  \"CADD EL DUENDE \" Cooperativa Stranaidea",
	"Autonomia Merida Comunità alloggio Cooperativa Valpiana",
	"Gruppo Appartamento disabilità COOP. SAN DONATO",
	"ASSOCIAZIONE YWCA-UCDG Foyer Torino",
	"Spazi di Vita Centro Diurno Fondazione AGAPE dello Spirito Santo",
	"Villa Lauro CAD Fondazione AGAPE dello Spirito Santo",
	"Comunità Terapeutica Arco Gruppo Arco",
	"Comunità i Passi COOPERATIVA I PASSI STRADA CASTELLO DI MIRAFIORI 142/8 10135 TORINO",
	"CAD  \"Laboratorio Zanzara \" Cooperatiova sociale ONLUS",
	"Accoglienza LIBERITUTTI COOP. LIBERITUTTI",
	"Accoglienza Ass. ULIVO",
	"S.E.R. L’Orobilogio Coop Stranaidea",
	"Abitare Sociale  \"Ostello Abbadia \" Ostello Dell'Antica Abbadia",
	"RAA Bricca Coop. Il Quadrifoglio",
	"Residenza Nuova Aurora GVV Torino",
	"Comunità Stella Polare COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus VIA LE CHIUSE 59 10146 TORINO",
	"CAD Casa di Zenzero Coop Stranaidea",
	"Centro CDSR In&Out Coop Stranaidea",
	/*DORMITORI*/
	"Dormitorio Ghedini COOPERATIVA ANIMAZIONE VALDOCCO s.c.s. onlus 10146 TORINO Via Le Chiuse 59, Torino",
	"Dormitorio Massaua Cooperativa P.G. FRASSATI",
	"Casa di Ospitalità Tazzoli ATI STRANAIDEA",
	"Dormitorio Ghiacciaie Cooperativa P.G. FRASSATI",
	"Dormitorio Carrera Cooperativa STRANAIDEA",
	"Casa di Ospitalità Notturna Gruppo Abele",
	"Dormitorio Reiss Romoli Cooperativa P. G. Frassati",
	"Dormitorio Sermig Caritas/SERMIG",
	"Dormitorio Lascaris Cooperativa P.G. FRASSATI",
	"Residenza Marsigli Cooperativa Aeris",
	"Presidio Umanitario Via Traves 15 CRI",
	"COTTOLENGO /CRI Via Andreis 28",
	"Caritas Diocesana / ASL Villa Pellizzari Corso Casale 396",
	"Caritas Diocesana \"Carlo Alberto\" Corso Casale 56",
	"Caritas Diocesana Via Arcivescovado 12c",
	
	/*STUDENTATI*/
	"Collegio Universitario Renato Einaudi Sede di Corso Lione 24",
	"Collegio Universitario Renato Einaudi Sede di Via Galliari Sez. Valentino",
	"Studentato Collegio San Gioacchino",
	"Housing San Salvario Luoghi Comuni San Salvario",
	"Campus Sanpaolo Cooperativa DOC",
	"EDISU Residenza Borsellino",
	"EDISU Residenza Olimpia",
	"EDISU Residenza San Liborio",
	"EDISU Residenza Verdi",
]
